import { render, staticRenderFns } from "./AfterSaleItem.vue?vue&type=template&id=2234e176&scoped=true&"
import script from "./AfterSaleItem.vue?vue&type=script&lang=js&"
export * from "./AfterSaleItem.vue?vue&type=script&lang=js&"
import style0 from "./AfterSaleItem.vue?vue&type=style&index=0&id=2234e176&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234e176",
  null
  
)

export default component.exports